import {useEffect, useState} from "react";
import type { ContextProps } from '../../../../types';
import {PageTitle} from "../../../../Components/Landmarks";
import {AphCatalogItemView} from "./AphCatalogItemView";
import {emptyGuid} from "../../../../Utilities/commonUtilities";
import {aphCatalogItemModel, emptyAphCatalogItemModel} from "./aphCatalogItemFactory";
import {locations} from "../../../../Utilities/Location";
import {aphCatalogItemApi} from "./aphCatalogItemApi";
import {SYSTEM_TYPES} from "../../libraryConstants";
import {getSystemTypeTextByValue} from "../../libraryUtility";

export const AphCatalogItemContainer = ({
                                         handleApiCall,
                                         catalogItemId,
                                         redirect,
                                         systemType,
                                     }: ContextProps) => {

    const [aphCatalogItem, setAphCatalogItem] = useState<Record<string, unknown>>();
    const isEdit = catalogItemId && catalogItemId !== emptyGuid;

    const handleReturn = () => {
        const selectedSystemType = systemType || aphCatalogItem?.systemType;
        redirect(locations.APH_CATALOG.getLink(selectedSystemType).to)
    };

    const handleSaveAphCatalogItem = async (aphCatalogItemModel: Record<string, unknown>) => {
        if(isEdit)
             return handleApiCall(() => aphCatalogItemApi.UpdateAphCatalogItem(aphCatalogItemModel), handleReturn);
        else
            return handleApiCall(() => aphCatalogItemApi.AddAphCatalogItem(aphCatalogItemModel), handleReturn);
    };

    const loadAphCatalogItemResult = (result: Record<string, unknown>) => {
        const aphCatalogItem = aphCatalogItemModel(result);
        setAphCatalogItem(aphCatalogItem);
    };

    useEffect(() => {

        const newAphCatalogItem = {
            ...emptyAphCatalogItemModel,
            systemType
        }
        const getAphCatalogItem = () => {
            handleApiCall(() => aphCatalogItemApi.GetAphCatalogItemById(catalogItemId), (results = newAphCatalogItem) => loadAphCatalogItemResult(results));
        }

        if (isEdit && !aphCatalogItem)
            getAphCatalogItem();
        else
            setAphCatalogItem(newAphCatalogItem);

    }, [catalogItemId]);

    if (!aphCatalogItem) return <></>;

    return <>
        <PageTitle h1={`${getSystemTypeTextByValue(SYSTEM_TYPES.APH.toString())} Catalog Item`}/>
        <AphCatalogItemView
            handleSaveAphCatalogItem={handleSaveAphCatalogItem}
            handleReturn={handleReturn}
            aphCatalogItem={aphCatalogItem}
        />
    </>;
};
